<template>
  <div class="car-select">
    <div class="car-select-block" @click="toggle" v-if="value && value.name">{{value.name}}</div>
    <div class="car-select-block place-holder" @click="toggle" v-else>{{placeholder || "请选择"}}</div>
    <transition name="fade" mode="out-in">
      <car-choose v-if="showCarChoose" @change="change" :value="value"></car-choose>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.car-select {
  flex: 1 0 0;
  display: inline-block;
  height: 100%;
}

.car-select {
  position: relative;
  font-size: $ucar_font_h4;
  text-align: right;
  line-height: 100px;
  height: 100%;
  padding-right: 40px;
  color: $ucar_font_color;
  min-width: 0;

  .car-select-block {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.car-select::after {
  position: absolute;
  right: 5px;
  top: 50%;
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border-bottom: 2px solid $ucar_font_assist_color;
  border-right: 2px solid $ucar_font_assist_color;
  transform: translate3d(0, -50%, 0) rotate(-45deg);
  box-sizing: border-box;
}

.place-holder {
  color: $ucar_font_assist_color;
}
</style>

<script>
import carChoose from './car-choose'

export default {
  data () {
    return {
      showCarChoose: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Object, String],
      default: () => {}
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  components: {
    'car-choose': carChoose
  },
  methods: {
    change (val) {
      this.showCarChoose = false
      if (val) this.$emit('input', val)
    },
    toggle () {
      this.showCarChoose = !this.showCarChoose
    }
  }
}
</script>
